module.exports = __webpack_public_path__ + "media/lingshi.119a3e76.mp3";